export enum Team {
  CeWeb = 'CeWeb',
  CustomerFoundations = 'CustomerFoundations',
  Loyalty = 'Loyalty',
}
